module.exports = __webpack_public_path__ + "img/question-mark.0efa05c0.svg";